import {AnnualFormType} from "./types";

export const noFormFieldsWithPrices = (formType:AnnualFormType) => {
	const type = formType == "signup" ? "signup" : "renewal"
	return `No ${type} form fields exist with prices.`
}

export const currentlyConfiguredViaStandardCostItem = (annualCostTitle:string) =>
	`The pro-rata period for this field is currently configured via the ${annualCostTitle} Cost Item above.`

export const noFormFieldsWithPrices_requiresConfiguration = (type:AnnualFormType) =>
	noFormFieldsWithPrices(type) + " Configure a field with prices so it can be selected for this cost item."

export const cantUseFieldsDueToAutoRenewal = "Can't configure form field pricing for this pricing option, as it makes use of auto renewal.";


// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/common/strings.ts